<template>
  <div
    class="relative shadow-lg bg-MenuFood text-white overflow-hidden transition-all m-2 rounded-xl"
    :class="{ grayscale: food.statuskala === 1 }"
    @touchstart="toggleAnimation($event)"
    @touchend="toggleAnimation($event)"
    v-if="food.kala !== 31890051 && food.kala !== 21590256"
  >
    <router-link :to="'/food/' + food.kala" class="flex flex-row p-4 relative">
      <div class="relative">
        <img
          :src="food.imgurl"
          alt=""
          class="rounded-[100%] w-24 shadow-2xl"
          @error="
            $event.target.src = require('@/assets/img/food_placeholder.png')
          "
        />
      </div>
      <div class="p-2">
        <h4 class="text-sm">{{ food.kala_Name }}</h4>
        <h6 class="text-xs mt-2">
          قیمت:
          <span class="text-sm text-ColorNerkh font-bold">{{
            $helper.priceFormatter(
              food.nerkh_With_Maliat_With_Detail / 10,
              false
            )
          }}</span>
          تومان
        </h6>
      </div>
    </router-link>

    <div
      class="absolute top-0 h-full w-full bg-gray-400/70"
      v-if="food.statuskala === 1"
    ></div>
    <span class="sold_out" v-if="food.statuskala === 1">تمام شد</span>
  </div>
</template>

<script>
export default {
  name: "MenuFoodCard",
  props: ["food"],
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle("scale-95");
      event.currentTarget.classList.toggle("shadow-md");
    },
  },
};
</script>

<style scoped>
.sold_out {
  top: 2em;
  left: -4em;
  color: #fff;
  display: block;
  position: absolute;
  text-align: center;
  text-decoration: none;
  letter-spacing: 0.06em;
  background-color: #a00;
  padding: 0.5em 5em 0.4em 5em;
  text-shadow: 0 0 0.75em #444;
  box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.5);
  font: 12px/1.2em iransans;
  font-family: iransans;
  -webkit-text-shadow: 0 0 0.75em #444;
  -webkit-box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.5);
  -webkit-transform: rotate(-45deg) scale(0.75, 1);
  z-index: 10;
}
.sold_out:before {
  content: "";
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  margin: -0.3em -5em;
  transform: scale(0.7);
  -webkit-transform: scale(0.7);
  border: 2px rgba(255, 255, 255, 0.7) dashed;
}
</style>
